import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, ownerOnly = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[color:var(--owc-navy)]">
        <div className="animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (ownerOnly && user.role !== "owner") return <Navigate to="/admin" replace />;
  return children;
}
